import React from 'react';

export function usePageList(load, params) {
	const [data, setData] = React.useState([]);
	const [isLoading, setLoading] = React.useState(false);

	const [pagination, setPagination] = React.useState({
		page: params?.page || 1,
		pageSize: params?.pageSize || 10,
	});

	const loadData = React.useCallback(async (params) => {
		setLoading(true);
		return await load(params).then(setData)
			.finally(() => setLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setPaginationHandler = React.useCallback(async (pagination) => {
		return await loadData(pagination).then(() => setPagination(pagination));
	}, [loadData]);

	const goToPage = React.useCallback(async (nextPage) => {
		if (nextPage >= 1 && nextPage !== pagination.page) {
			// setPagination(v => ({ ...v, page: nextPage }));
			setPaginationHandler({ ...pagination, page: nextPage });
		}
	}, [pagination, setPaginationHandler]);

	const nextPage = React.useCallback(() => {
		return goToPage(pagination.page + 1);
	}, [goToPage, pagination.page]);

	const backPage = React.useCallback(() => {
		return goToPage(pagination.page - 1);
	}, [goToPage, pagination.page]);

	const setPageSizeHandler = React.useCallback(async (pageSize) => {
		if (pageSize === pagination.pageSize) return;
		setPaginationHandler({ page: 1, pageSize });
	}, [pagination.pageSize, setPaginationHandler]);

	const canGoBackPage = React.useMemo(() => pagination.page > 1, [pagination.page]);

	const canGoNextPage = React.useMemo(() => true, []);

	React.useEffect(() => {
		loadData(pagination);
	}, [loadData, pagination]);

	return ({
		data,
		page: pagination.page,
		pageSize: pagination.pageSize,
		setPageSize: setPageSizeHandler,
		nextPage,
		canGoBackPage,
		canGoNextPage,
		backPage,
		goToPage,
		isLoading,
		setData,
	});
}
